/* eslint-disable */

export default {
    data: [
        { id: 110000, text: '北京', children: [{ id: 110100, text: '北京市' }] },
        { id: 120000, text: '天津', children: [{ id: 120100, text: '天津市' }] },
        {
            id: 130000,
            text: '河北省',
            children: [
                { id: 130100, text: '石家庄市' },
                { id: 130200, text: '唐山市' },
                { id: 130300, text: '秦皇岛市' },
                { id: 130400, text: '邯郸市' },
                { id: 130500, text: '邢台市' },
                { id: 130600, text: '保定市' },
                { id: 130700, text: '张家口市' },
                { id: 130800, text: '承德市' },
                { id: 130900, text: '沧州市' },
                { id: 131000, text: '廊坊市' },
                { id: 131100, text: '衡水市' }
            ]
        },
        {
            id: 140000,
            text: '山西省',
            children: [
                { id: 140100, text: '太原市' },
                { id: 140200, text: '大同市' },
                { id: 140300, text: '阳泉市' },
                { id: 140400, text: '长治市' },
                { id: 140500, text: '晋城市' },
                { id: 140600, text: '朔州市' },
                { id: 140700, text: '晋中市' },
                { id: 140800, text: '运城市' },
                { id: 140900, text: '忻州市' },
                { id: 141000, text: '临汾市' },
                { id: 141100, text: '吕梁市' }
            ]
        },
        {
            id: 150000,
            text: '内蒙古自治区',
            children: [
                { id: 150100, text: '呼和浩特市' },
                { id: 150200, text: '包头市' },
                { id: 150300, text: '乌海市' },
                { id: 150400, text: '赤峰市' },
                { id: 150500, text: '通辽市' },
                { id: 150600, text: '鄂尔多斯市' },
                { id: 150700, text: '呼伦贝尔市' },
                { id: 150800, text: '巴彦淖尔市' },
                { id: 150900, text: '乌兰察布市' },
                { id: 152200, text: '兴安盟' },
                { id: 152500, text: '锡林郭勒盟' },
                { id: 152900, text: '阿拉善盟' }
            ]
        },
        {
            id: 210000,
            text: '辽宁省',
            children: [
                { id: 210100, text: '沈阳市' },
                { id: 210200, text: '大连市' },
                { id: 210300, text: '鞍山市' },
                { id: 210400, text: '抚顺市' },
                { id: 210500, text: '本溪市' },
                { id: 210600, text: '丹东市' },
                { id: 210700, text: '锦州市' },
                { id: 210800, text: '营口市' },
                { id: 210900, text: '阜新市' },
                { id: 211000, text: '辽阳市' },
                { id: 211100, text: '盘锦市' },
                { id: 211200, text: '铁岭市' },
                { id: 211300, text: '朝阳市' },
                { id: 211400, text: '葫芦岛市' }
            ]
        },
        {
            id: 220000,
            text: '吉林省',
            children: [
                { id: 220100, text: '长春市' },
                { id: 220200, text: '吉林市' },
                { id: 220300, text: '四平市' },
                { id: 220400, text: '辽源市' },
                { id: 220500, text: '通化市' },
                { id: 220600, text: '白山市' },
                { id: 220700, text: '松原市' },
                { id: 220800, text: '白城市' },
                { id: 222400, text: '延边朝鲜族自治州' }
            ]
        },
        {
            id: 230000,
            text: '黑龙江省',
            children: [
                { id: 230100, text: '哈尔滨市' },
                { id: 230200, text: '齐齐哈尔市' },
                { id: 230300, text: '鸡西市' },
                { id: 230400, text: '鹤岗市' },
                { id: 230500, text: '双鸭山市' },
                { id: 230600, text: '大庆市' },
                { id: 230700, text: '伊春市' },
                { id: 230800, text: '佳木斯市' },
                { id: 230900, text: '七台河市' },
                { id: 231000, text: '牡丹江市' },
                { id: 231100, text: '黑河市' },
                { id: 231200, text: '绥化市' },
                { id: 232700, text: '大兴安岭地区' }
            ]
        },
        { id: 310000, text: '上海', children: [{ id: 310100, text: '上海市' }] },
        {
            id: 320000,
            text: '江苏省',
            children: [
                { id: 320100, text: '南京市' },
                { id: 320200, text: '无锡市' },
                { id: 320300, text: '徐州市' },
                { id: 320400, text: '常州市' },
                { id: 320500, text: '苏州市' },
                { id: 320600, text: '南通市' },
                { id: 320700, text: '连云港市' },
                { id: 320800, text: '淮安市' },
                { id: 320900, text: '盐城市' },
                { id: 321000, text: '扬州市' },
                { id: 321100, text: '镇江市' },
                { id: 321200, text: '泰州市' },
                { id: 321300, text: '宿迁市' }
            ]
        },
        {
            id: 330000,
            text: '浙江省',
            children: [
                { id: 330100, text: '杭州市' },
                { id: 330200, text: '宁波市' },
                { id: 330300, text: '温州市' },
                { id: 330400, text: '嘉兴市' },
                { id: 330500, text: '湖州市' },
                { id: 330600, text: '绍兴市' },
                { id: 330700, text: '金华市' },
                { id: 330800, text: '衢州市' },
                { id: 330900, text: '舟山市' },
                { id: 331000, text: '台州市' },
                { id: 331100, text: '丽水市' }
            ]
        },
        {
            id: 340000,
            text: '安徽省',
            children: [
                { id: 340100, text: '合肥市' },
                { id: 340200, text: '芜湖市' },
                { id: 340300, text: '蚌埠市' },
                { id: 340400, text: '淮南市' },
                { id: 340500, text: '马鞍山市' },
                { id: 340600, text: '淮北市' },
                { id: 340700, text: '铜陵市' },
                { id: 340800, text: '安庆市' },
                { id: 341000, text: '黄山市' },
                { id: 341100, text: '滁州市' },
                { id: 341200, text: '阜阳市' },
                { id: 341300, text: '宿州市' },
                { id: 341500, text: '六安市' },
                { id: 341600, text: '亳州市' },
                { id: 341700, text: '池州市' },
                { id: 341800, text: '宣城市' }
            ]
        },
        {
            id: 350000,
            text: '福建省',
            children: [
                { id: 350100, text: '福州市' },
                { id: 350200, text: '厦门市' },
                { id: 350300, text: '莆田市' },
                { id: 350400, text: '三明市' },
                { id: 350500, text: '泉州市' },
                { id: 350600, text: '漳州市' },
                { id: 350700, text: '南平市' },
                { id: 350800, text: '龙岩市' },
                { id: 350900, text: '宁德市' }
            ]
        },
        {
            id: 360000,
            text: '江西省',
            children: [
                { id: 360100, text: '南昌市' },
                { id: 360200, text: '景德镇市' },
                { id: 360300, text: '萍乡市' },
                { id: 360400, text: '九江市' },
                { id: 360500, text: '新余市' },
                { id: 360600, text: '鹰潭市' },
                { id: 360700, text: '赣州市' },
                { id: 360800, text: '吉安市' },
                { id: 360900, text: '宜春市' },
                { id: 361000, text: '抚州市' },
                { id: 361100, text: '上饶市' }
            ]
        },
        {
            id: 370000,
            text: '山东省',
            children: [
                { id: 370100, text: '济南市' },
                { id: 370200, text: '青岛市' },
                { id: 370300, text: '淄博市' },
                { id: 370400, text: '枣庄市' },
                { id: 370500, text: '东营市' },
                { id: 370600, text: '烟台市' },
                { id: 370700, text: '潍坊市' },
                { id: 370800, text: '济宁市' },
                { id: 370900, text: '泰安市' },
                { id: 371000, text: '威海市' },
                { id: 371100, text: '日照市' },
                { id: 371200, text: '莱芜市' },
                { id: 371300, text: '临沂市' },
                { id: 371400, text: '德州市' },
                { id: 371500, text: '聊城市' },
                { id: 371600, text: '滨州市' },
                { id: 371700, text: '菏泽市' }
            ]
        },
        {
            id: 410000,
            text: '河南省',
            children: [
                { id: 410100, text: '郑州市' },
                { id: 410200, text: '开封市' },
                { id: 410300, text: '洛阳市' },
                { id: 410400, text: '平顶山市' },
                { id: 410500, text: '安阳市' },
                { id: 410600, text: '鹤壁市' },
                { id: 410700, text: '新乡市' },
                { id: 410800, text: '焦作市' },
                { id: 410881, text: '济源市' },
                { id: 410900, text: '濮阳市' },
                { id: 411000, text: '许昌市' },
                { id: 411100, text: '漯河市' },
                { id: 411200, text: '三门峡市' },
                { id: 411300, text: '南阳市' },
                { id: 411400, text: '商丘市' },
                { id: 411500, text: '信阳市' },
                { id: 411600, text: '周口市' },
                { id: 411700, text: '驻马店市' }
            ]
        },
        {
            id: 420000,
            text: '湖北省',
            children: [
                { id: 420100, text: '武汉市' },
                { id: 420200, text: '黄石市' },
                { id: 420300, text: '十堰市' },
                { id: 420500, text: '宜昌市' },
                { id: 420600, text: '襄阳市' },
                { id: 420700, text: '鄂州市' },
                { id: 420800, text: '荆门市' },
                { id: 420900, text: '孝感市' },
                { id: 421000, text: '荆州市' },
                { id: 421100, text: '黄冈市' },
                { id: 421200, text: '咸宁市' },
                { id: 421300, text: '随州市' },
                { id: 422800, text: '恩施土家族苗族自治州' },
                { id: 429004, text: '仙桃市' },
                { id: 429005, text: '潜江市' },
                { id: 429006, text: '天门市' },
                { id: 429021, text: '神农架林区' }
            ]
        },
        {
            id: 430000,
            text: '湖南省',
            children: [
                { id: 430100, text: '长沙市' },
                { id: 430200, text: '株洲市' },
                { id: 430300, text: '湘潭市' },
                { id: 430400, text: '衡阳市' },
                { id: 430500, text: '邵阳市' },
                { id: 430600, text: '岳阳市' },
                { id: 430700, text: '常德市' },
                { id: 430800, text: '张家界市' },
                { id: 430900, text: '益阳市' },
                { id: 431000, text: '郴州市' },
                { id: 431100, text: '永州市' },
                { id: 431200, text: '怀化市' },
                { id: 431300, text: '娄底市' },
                { id: 433100, text: '湘西土家族苗族自治州' }
            ]
        },
        {
            id: 440000,
            text: '广东省',
            children: [
                { id: 440100, text: '广州市' },
                { id: 440200, text: '韶关市' },
                { id: 440300, text: '深圳市' },
                { id: 440400, text: '珠海市' },
                { id: 440500, text: '汕头市' },
                { id: 440600, text: '佛山市' },
                { id: 440700, text: '江门市' },
                { id: 440800, text: '湛江市' },
                { id: 440900, text: '茂名市' },
                { id: 441200, text: '肇庆市' },
                { id: 441300, text: '惠州市' },
                { id: 441400, text: '梅州市' },
                { id: 441500, text: '汕尾市' },
                { id: 441600, text: '河源市' },
                { id: 441700, text: '阳江市' },
                { id: 441800, text: '清远市' },
                { id: 441900, text: '东莞市' },
                { id: 442000, text: '中山市' },
                { id: 442101, text: '东沙群岛' },
                { id: 445100, text: '潮州市' },
                { id: 445200, text: '揭阳市' },
                { id: 445300, text: '云浮市' }
            ]
        },
        {
            id: 450000,
            text: '广西壮族自治区',
            children: [
                { id: 450100, text: '南宁市' },
                { id: 450200, text: '柳州市' },
                { id: 450300, text: '桂林市' },
                { id: 450400, text: '梧州市' },
                { id: 450500, text: '北海市' },
                { id: 450600, text: '防城港市' },
                { id: 450700, text: '钦州市' },
                { id: 450800, text: '贵港市' },
                { id: 450900, text: '玉林市' },
                { id: 451000, text: '百色市' },
                { id: 451100, text: '贺州市' },
                { id: 451200, text: '河池市' },
                { id: 451300, text: '来宾市' },
                { id: 451400, text: '崇左市' }
            ]
        },
        {
            id: 460000,
            text: '海南省',
            children: [
                { id: 460100, text: '海口市' },
                { id: 460200, text: '三亚市' },
                { id: 460300, text: '三沙市' },
                { id: 469001, text: '五指山市' },
                { id: 469002, text: '琼海市' },
                { id: 469003, text: '儋州市' },
                { id: 469005, text: '文昌市' },
                { id: 469006, text: '万宁市' },
                { id: 469007, text: '东方市' },
                { id: 469025, text: '定安县' },
                { id: 469026, text: '屯昌县' },
                { id: 469027, text: '澄迈县' },
                { id: 469028, text: '临高县' },
                { id: 469030, text: '白沙黎族自治县' },
                { id: 469031, text: '昌江黎族自治县' },
                { id: 469033, text: '乐东黎族自治县' },
                { id: 469034, text: '陵水黎族自治县' },
                { id: 469035, text: '保亭黎族苗族自治县' },
                { id: 469036, text: '琼中黎族苗族自治县' }
            ]
        },
        { id: 500000, text: '重庆', children: [{ id: 500100, text: '重庆市' }] },
        {
            id: 510000,
            text: '四川省',
            children: [
                { id: 510100, text: '成都市' },
                { id: 510300, text: '自贡市' },
                { id: 510400, text: '攀枝花市' },
                { id: 510500, text: '泸州市' },
                { id: 510600, text: '德阳市' },
                { id: 510700, text: '绵阳市' },
                { id: 510800, text: '广元市' },
                { id: 510900, text: '遂宁市' },
                { id: 511000, text: '内江市' },
                { id: 511100, text: '乐山市' },
                { id: 511300, text: '南充市' },
                { id: 511400, text: '眉山市' },
                { id: 511500, text: '宜宾市' },
                { id: 511600, text: '广安市' },
                { id: 511700, text: '达州市' },
                { id: 511800, text: '雅安市' },
                { id: 511900, text: '巴中市' },
                { id: 512000, text: '资阳市' },
                { id: 513200, text: '阿坝藏族羌族自治州' },
                { id: 513300, text: '甘孜藏族自治州' },
                { id: 513400, text: '凉山彝族自治州' }
            ]
        },
        {
            id: 520000,
            text: '贵州省',
            children: [
                { id: 520100, text: '贵阳市' },
                { id: 520200, text: '六盘水市' },
                { id: 520300, text: '遵义市' },
                { id: 520400, text: '安顺市' },
                { id: 522200, text: '铜仁市' },
                { id: 522300, text: '黔西南布依族苗族自治州' },
                { id: 522400, text: '毕节市' },
                { id: 522600, text: '黔东南苗族侗族自治州' },
                { id: 522700, text: '黔南布依族苗族自治州' }
            ]
        },
        {
            id: 530000,
            text: '云南省',
            children: [
                { id: 530100, text: '昆明市' },
                { id: 530300, text: '曲靖市' },
                { id: 530400, text: '玉溪市' },
                { id: 530500, text: '保山市' },
                { id: 530600, text: '昭通市' },
                { id: 530700, text: '丽江市' },
                { id: 530800, text: '普洱市' },
                { id: 530900, text: '临沧市' },
                { id: 532300, text: '楚雄彝族自治州' },
                { id: 532500, text: '红河哈尼族彝族自治州' },
                { id: 532600, text: '文山壮族苗族自治州' },
                { id: 532800, text: '西双版纳傣族自治州' },
                { id: 532900, text: '大理白族自治州' },
                { id: 533100, text: '德宏傣族景颇族自治州' },
                { id: 533300, text: '怒江傈僳族自治州' },
                { id: 533400, text: '迪庆藏族自治州' }
            ]
        },
        {
            id: 540000,
            text: '西藏自治区',
            children: [
                { id: 540100, text: '拉萨市' },
                { id: 542100, text: '昌都市' },
                { id: 542200, text: '山南市' },
                { id: 542300, text: '日喀则市' },
                { id: 542400, text: '那曲市' },
                { id: 542500, text: '阿里地区' },
                { id: 542600, text: '林芝市' }
            ]
        },
        {
            id: 610000,
            text: '陕西省',
            children: [
                { id: 610100, text: '西安市' },
                { id: 610200, text: '铜川市' },
                { id: 610300, text: '宝鸡市' },
                { id: 610400, text: '咸阳市' },
                { id: 610500, text: '渭南市' },
                { id: 610600, text: '延安市' },
                { id: 610700, text: '汉中市' },
                { id: 610800, text: '榆林市' },
                { id: 610900, text: '安康市' },
                { id: 611000, text: '商洛市' }
            ]
        },
        {
            id: 620000,
            text: '甘肃省',
            children: [
                { id: 620100, text: '兰州市' },
                { id: 620200, text: '嘉峪关市' },
                { id: 620300, text: '金昌市' },
                { id: 620400, text: '白银市' },
                { id: 620500, text: '天水市' },
                { id: 620600, text: '武威市' },
                { id: 620700, text: '张掖市' },
                { id: 620800, text: '平凉市' },
                { id: 620900, text: '酒泉市' },
                { id: 621000, text: '庆阳市' },
                { id: 621100, text: '定西市' },
                { id: 621200, text: '陇南市' },
                { id: 622900, text: '临夏回族自治州' },
                { id: 623000, text: '甘南藏族自治州' }
            ]
        },
        {
            id: 630000,
            text: '青海省',
            children: [
                { id: 630100, text: '西宁市' },
                { id: 632100, text: '海东市' },
                { id: 632200, text: '海北藏族自治州' },
                { id: 632300, text: '黄南藏族自治州' },
                { id: 632500, text: '海南藏族自治州' },
                { id: 632600, text: '果洛藏族自治州' },
                { id: 632700, text: '玉树藏族自治州' },
                { id: 632800, text: '海西蒙古族藏族自治州' }
            ]
        },
        {
            id: 640000,
            text: '宁夏回族自治区',
            children: [
                { id: 640100, text: '银川市' },
                { id: 640200, text: '石嘴山市' },
                { id: 640300, text: '吴忠市' },
                { id: 640400, text: '固原市' },
                { id: 640500, text: '中卫市' }
            ]
        },
        {
            id: 650000,
            text: '新疆维吾尔自治区',
            children: [
                { id: 650100, text: '乌鲁木齐市' },
                { id: 650200, text: '克拉玛依市' },
                { id: 652100, text: '吐鲁番市' },
                { id: 652200, text: '哈密市' },
                { id: 652300, text: '昌吉回族自治州' },
                { id: 652700, text: '博尔塔拉蒙古自治州' },
                { id: 652800, text: '巴音郭楞蒙古自治州' },
                { id: 652900, text: '阿克苏地区' },
                { id: 653000, text: '克孜勒苏柯尔克孜自治州' },
                { id: 653100, text: '喀什地区' },
                { id: 653200, text: '和田地区' },
                { id: 654000, text: '伊犁哈萨克自治州' },
                { id: 654200, text: '塔城地区' },
                { id: 654300, text: '阿勒泰地区' },
                { id: 659000, text: '可克达拉市' },
                { id: 659001, text: '石河子市' },
                { id: 659002, text: '阿拉尔市' },
                { id: 659003, text: '图木舒克市' },
                { id: 659004, text: '五家渠市' },
                { id: 659005, text: '北屯市' },
                { id: 659006, text: '铁门关市' },
                { id: 659009, text: '昆玉市' }
            ]
        },
        {
            id: 710000,
            text: '台湾',
            children: [
                { id: 710100, text: '台北市' },
                { id: 710200, text: '高雄市' },
                { id: 710300, text: '台南市' },
                { id: 710400, text: '台中市' },
                { id: 710500, text: '金门县' },
                { id: 710600, text: '南投县' },
                { id: 710700, text: '基隆市' },
                { id: 710800, text: '新竹市' },
                { id: 710900, text: '嘉义市' },
                { id: 711100, text: '新北市' },
                { id: 711200, text: '宜兰县' },
                { id: 711300, text: '新竹县' },
                { id: 711400, text: '桃园县' },
                { id: 711500, text: '苗栗县' },
                { id: 711700, text: '彰化县' },
                { id: 711900, text: '嘉义县' },
                { id: 712100, text: '云林县' },
                { id: 712400, text: '屏东县' },
                { id: 712500, text: '台东县' },
                { id: 712600, text: '花莲县' },
                { id: 712700, text: '澎湖县' },
                { id: 712800, text: '连江县' }
            ]
        },
        {
            id: 810000,
            text: '香港',
            children: [{ id: 810100, text: '香港岛' }, { id: 810200, text: '九龙' }, { id: 810300, text: '新界' }]
        },
        { id: 820000, text: '澳门', children: [{ id: 820100, text: '澳门半岛' }, { id: 820200, text: '离岛' }] }
    ]
};
/* eslint-enable */
